import { CompanyTheme } from '../api/types';
import ApplyCompanyTheming from '../components/contexts/ApplyCompanyTheming';
import { useCompany } from '../components/contexts/CompanyContextManager';
import withPrivateAccess from '../utilities/withPrivateAccess';
import AdminInnerRouter from './AdminInnerRouter';
import AdminMetaData from './AdminMetaData';

const AdminRouter = () => {
    const company = useCompany(true);

    if (company) {
        return (
            <ApplyCompanyTheming overrideTheme={CompanyTheme.Admin}>
                <>
                    <AdminMetaData />
                    <AdminInnerRouter />
                </>
            </ApplyCompanyTheming>
        );
    }

    // move to the inner router
    return (
        <>
            <AdminMetaData />
            <AdminInnerRouter />
        </>
    );
};

export default withPrivateAccess(AdminRouter);
